import { useEffect, useState } from "react";
import api from "@services/api/client";

type EmailPreview = { name: string; label: string; html: string };

export const EmailDesigns = () => {
  const [previews, setPreviews] = useState<EmailPreview[]>([]);
  const [selected, setSelected] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/email-templates/preview")
      .then((res) => {
        setPreviews(res.data);
        if (res.data.length > 0) setSelected(res.data[0].name);
      })
      .finally(() => setLoading(false));
  }, []);

  const current = previews.find((p) => p.name === selected);

  return (
    <div className="flex flex-row h-full">
      {/* Sidebar */}
      <div className="w-52 min-w-52 border-r-1 pt-6 flex flex-col gap-1 px-2">
        <div className="text-h2 text-neutral-400 px-2 mb-8">Templates</div>
        {previews.map((p) => (
          <button
            key={p.name}
            onClick={() => setSelected(p.name)}
            className={`text-left px-3 py-1 rounded-lg text-h2 font-medium transition-colors ${
              selected === p.name
                ? "bg-neutral-100 text-black"
                : "text-neutral-400 hover:bg-neutral-50"
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {/* Preview */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {loading && (
          <div className="flex-1 flex items-center justify-center text-neutral-400 text-h3">
            Chargement…
          </div>
        )}
        {!loading && current && (
          <iframe
            key={current.name}
            srcDoc={current.html}
            className="flex-1 w-full border-none"
            sandbox="allow-same-origin"
          />
        )}
      </div>
    </div>
  );
};
